import { motion } from "framer-motion";

/**
 * A giant slow editorial marquee — like a magazine spread ticker.
 * Sits between sections and reinforces the brand statement typographically.
 */
export default function EditorialMarquee({
  words = ["Pay only when they're gone", "Ethically removed", "Google-compliant"],
  duration = 60,
}) {
  const line = words.join("  ✦  ");
  const items = new Array(4).fill(line);

  return (
    <section
      aria-hidden
      className="relative py-14 lg:py-20 overflow-hidden border-y border-white/[0.04] bg-[#080c17]"
    >
      {/* fade masks */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 z-10 bg-gradient-to-r from-[#080c17] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 z-10 bg-gradient-to-l from-[#080c17] to-transparent" />
      {/* subtle grain */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 30% 40%, rgba(212,175,55,0.15), transparent 40%), radial-gradient(circle at 70% 60%, rgba(16,185,129,0.1), transparent 40%)",
        }}
      />

      <motion.div
        className="flex whitespace-nowrap gap-16"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration, ease: "linear", repeat: Infinity }}
      >
        {items.map((t, i) => (
          <span
            key={i}
            className="font-display font-black italic tracking-tight text-[8vw] leading-none uppercase text-transparent"
            style={{
              WebkitTextStroke: "1.5px rgba(255,255,255,0.65)",
            }}
          >
            {t}
          </span>
        ))}
      </motion.div>
    </section>
  );
}
